<template>
  <a-drawer
    title="服务项管理"
    placement="right"
    :width="1200"
    :visible="innerVisible"
    @close="close"
    destroyOnClose>
    <a-card :bordered="false">
      <!-- 搜索条 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="服务名称">
                <a-input v-model="queryParam.name" placeholder="请输入" allow-clear @keyup.enter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" allow-clear>
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"> <a-icon type="search" />查询 </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"> <a-icon type="redo" />重置 </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作条 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.createForm.handleAdd(serviceId)"
          v-hasPermi="['7f86ff58f8338f71139a4215f04be21dc:0:c']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['7f86ff58f8338f71139a4215f04be21dd:0:d','7f86ff58f8338f71139a4215f04be21dq:0:q']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button
          type="danger"
          :disabled="deletableRows.length === 0"
          @click="handleDelete"
          v-hasPermi="['7f86ff58f8338f71139a4215f04be21dr:0:r']"
        >
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['7f86ff58f8338f71139a4215f04be21de:0:e']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          style="float: right"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 表格 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="rowSelection"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag color="red" v-if="record.status === 0">禁用</a-tag>
          <a-tag color="green" v-if="record.status === 1">正常</a-tag>
        </span>
        <span slot="grade" slot-scope="text, record">
          <a-tag color="green" v-if="record.parentId == 0">一层</a-tag>
          <a-tag color="orange" v-if="record.parentId == 1">二层</a-tag>
          <a-tag color="red" v-if="record.parentId == 2">三层</a-tag>
        </span>
        <div slot="pic" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.pic"
              style="width: 50px; height: 50px"
              @error="(e) => (e.target.src = errorImage)"
            />
          </div>
        </div>
        <div slot="icon" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.icon"
              style="width: 50px; height: 50px"
              @error="(e) => (e.target.src = errorImage)"
            />
          </div>
        </div>
        <span slot="operation" slot-scope="text, record">
          <a
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['7f86ff58f8338f71139a4215f04be21dd:0:d']"
          >
            修改
          </a>
          <a-divider type="vertical" v-if="record.status === 0" />
          <a-dropdown v-if="record.status === 0">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()"> 更多 <a-icon type="double-right" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDelete(record)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <!-- 新增/编辑弹窗 -->
    <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" />
  </a-drawer>
</template>
<script>
import { fetchList, delObj, statusObj } from '@/api/maintenance/serviceItem/index'
import CreateForm from '@/views/maintenance/serviceItem/modules/CreateForm.vue'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'ServiceItemDrawer',
  mixins: [tableMixin],
  components: { CreateForm },
  dicts: ['sys_enable_disable'],
  data() {
    return {
      innerVisible: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      errorImage: require('/src/assets/images/defaultImg.png'),
      total: 0,
      serviceId: '',
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        name: '',
        status: undefined,
        serviceId: '',
      },
      columns: [
        { title: '服务名称', dataIndex: 'name', align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '服务图片', dataIndex: 'pic', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '服务图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '备注', dataIndex: 'remark', ellipsis: true, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  computed: {
    /* 只有 status=0 的行才允许勾选 */
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.status !== 0, // 0=禁用/可删
          },
        }),
      }
    },
    /* 其余你原来就有的计算属性 … */
    deletableRows() {
      return this.selectedRows.filter((v) => v.status === 0)
    },
  },
  methods: {
    /* ---- 父级命令式调用 ---- */
    open(e) {
      this.queryParam.serviceId = e
      this.serviceId = e
      this.innerVisible = true
      this.getList()
    },
    close() {
      this.innerVisible = false
      this.resetQuery()
      this.onSelectChange([], [])
    },
    /* ---- 业务逻辑 ---- */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        name: '',
        serviceId: this.serviceId,
        status: undefined,
      }
      this.handleQuery()
    },
    handleStatusType(id, status) {
      statusObj({ id }).then(() => {
        this.$message.success('操作成功')
        this.getList()
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row) {
      const list = row?.id ? [row] : this.deletableRows
      if (!list.length) return this.$message.warn('没有可删除的数据')
      const ids = list.map((v) => ({ id: v.id }))
      this.$confirm({
        title: `确定删除 ${list.length} 条数据？`,
        onOk: () =>
          delObj(ids).then(() => {
            this.$message.success('删除成功')
            this.onSelectChange([], [])
            this.getList()
          }),
      })
    },
    handleExport() {
      this.$confirm({
        title: '是否确认导出？',
        content: '此操作将导出当前条件下所有数据',
        onOk: () => this.download('upkeep/service/item/export', this.queryParam, `serviceItem_${Date.now()}.xlsx`),
      })
    },
  },
}
</script>
